import React, { useState, useEffect } from 'react';

function ModalComponent(props) {
    let modalMeta = {
        "add": { "modal_id": "addContent", "form_id": "add_form", "modal_button_id": "addRow" },
        "addSec": { "modal_id": "addSecondaryContent", "form_id": "", "modal_button_id": "addRow" },
        "bulk": { "modal_id": "addBulkContent", "form_id": "bulk_form", "modal_button_id": "bulkEdit" },
        "import": { "modal_id": "importModal", "form_id": "import_form", "modal_button_id": "importValue" },
        "update": { "modal_id": "updateModal", "form_id": "update_form", "modal_button_id": "updateRow" },
    }

    const [generateModalVar, setGenerateModalVar] = useState(null)

    function generateModal(modalConfig) {

        var modal = null;
        let button_id = (modalMeta[modalConfig["action"]] !== null && modalMeta[modalConfig["action"]] !== undefined) ? modalMeta[modalConfig["action"]]["modal_button_id"] : `${modalConfig["form_name"]}_button`;

        button_id = modalConfig['buttonId'] ? modalConfig['buttonId'] : button_id;

        let leftButtonId = modalConfig['leftButtonId'] ? modalConfig['leftButtonId'] : `${modalConfig["form_name"]}_leftButton`

        let buttonClass = modalConfig['buttonClass'] ? modalConfig['buttonClass'] : "btn-primary";
        let disabledFlag = modalConfig['disabledFlag'] === true ? true : false;
        let button = (<button type={modalConfig['buttonType'] ? modalConfig['buttonType'] : `button`} id={button_id} onClick={(e)=>{typeof props?.action=="function" ? props?.action(e): null}} className={`btn btn-sm ${buttonClass} mg-l-15 mg-b-5`} disabled={disabledFlag}>{modalConfig["button_name"]}</button>);

        if (modalConfig["isLoading"] !== undefined && modalConfig["isLoading"] !== null && modalConfig["isLoading"]) {
            button = (<button className={`btn btn-sm btn-primary mg-l-15 mg-b-5`} id={button_id} type="button" disabled>
                <span className="spinner-border spinner-border-sm mg-x-5" role="status" aria-hidden="true"></span>
                Loading Data...
            </button>);
        }

        if (modalConfig["display"]) {

            let modal_id = null;
            let form_id = null;
            let modal_size = null;
            let modal_height_class = null;
            let formKey = modalConfig['formKey'];
            let modalStyle = null;
            if (modalMeta[modalConfig["action"]] !== null && modalMeta[modalConfig["action"]] !== undefined) {
                modal_id = modalMeta[modalConfig["action"]]["modal_id"];
                form_id = modalMeta[modalConfig["action"]]["form_id"]
            }
            else {
                modal_id = modalConfig['id'];
                form_id = modalConfig['form_id'];
            }


            if (modalConfig['size'] !== null && modalConfig['size'] !== undefined) {
                if (modalConfig['size'] == "large") {
                    modal_size = "modal-lg";
                } else {
                    modal_size = modalConfig['size'];
                }
            }
            if (modalConfig['height'] !== null && modalConfig['height'] !== undefined) {
                modal_height_class = `ht-${modalConfig['height']}`;
                modalStyle = { overflow: "auto" };
            }
            if (modalConfig['bodyStyle']) {
                modalStyle = { padding: '0px' }
            }
            modal = (<div id={modal_id} className="modal fade" role="dialog" data-keyboard="false" data-backdrop="static"  onClick={(e) => {
                // Only trigger cancelEvent if the backdrop (not modal content) was clicked
                if (e.target.id === modal_id) {
                    if (props.cancelEvent) {
                        jQuery(`#${modal_id}`).modal('toggle');
                        props.cancelEvent();
                    }
                }
            }}
            >
                {/* <div className="modal-dialog"> */}
                <div className={`modal-dialog ${modal_size}`} role="document">
                    <div className="modal-content">
                        <form encType="multipart/form-data" autoComplete="off" name={modalConfig["form_name"]} id={form_id} onSubmit={props.formSubmit ? props.formSubmit : null} key={formKey ? formKey : form_id}>
                            <div className="modal-header">
                                <h5 className="modal-title">{modalConfig["title"]}</h5>
                                <button
                                    id={`close_${modal_id}`}
                                    type="button"
                                    className="close"
                                    onClick={
                                        props.cancelEvent
                                            ? () => {
                                                jQuery(`#${modal_id}`).modal('toggle');
                                                props.cancelEvent()
                                            }
                                            : null
                                    }
                                    data-bs-dismiss={props.cancelEvent ? null : "modal"}
                                >&times;</button>
                            </div>

                            <div className={`modal-body ${modal_height_class}`} style={modalStyle}>
                                <div className={props.conditionalFormatting ? 'row' : ''}>
                                    {modalConfig["body"] ? modalConfig["body"] : <div className="m-3">
                                        <span className="alert-danger pd-5 " style={{ lineHeight: "2" }}>An error occurred. Please refresh and try again. If the problem continues, reach out to support..</span>
                                    </div>}
                                </div>
                            </div>

                            {!modalConfig.noFooter
                                ? <div className="modal-footer">
                                    {modalConfig['leftButtonDisplay']
                                        ? modalConfig['leftButtons'].map(function (innerElement) {
                                            return (<button type={modalConfig['buttonType'] ? modalConfig['buttonType'] : 'button'} id={leftButtonId} onClick={innerElement.action} className={`btn btn-sm btn-${innerElement.buttonClass}`} disabled={false}>{innerElement.name}</button>)
                                        })
                                        : null}
                                    {button}
                                    <button
                                        type="button"
                                        id={`cancel_${modal_id}`}
                                        className="btn btn-sm btn-primary mg-l-15 mg-b-5"
                                        onClick={
                                            props.cancelEvent
                                                ? () => {
                                                    jQuery(`#${modal_id}`).modal('toggle');
                                                    props.cancelEvent()
                                                }
                                                : null
                                        }
                                        data-bs-dismiss={props.cancelEvent ? null : "modal"}
                                    >Cancel</button>
                                </div>
                                : null}
                        </form>
                    </div>
                </div>
            </div>);

            return modal;
        }


    }

    useEffect(() => {
        setGenerateModalVar(generateModal(props.modalConfig))
    }, [props.modalConfig && props.modalConfig.formKey])

    return (
        <>{generateModalVar}</>
    );
}

export default ModalComponent;